export default __webpack_public_path__ + "img/arrowDown.84d9bdfc.svg";